// extracted by mini-css-extract-plugin
export default {"alertContainer":"adOv0najXz","inputWithButton":"kBGCAePCIs","inputWrapper":"jctSrmD__9","activateByDefaultAlert":"Mfk9hWnMR3"};